<template>
  <div class="settings-card">
    <div class="card-header">
      <h3><i class="fas fa-user-shield"></i> Phân quyền Người dùng & Vai trò</h3>
    </div>
    <div class="card-body">
      <div class="role-selector mb-4">
        <label>Chọn vai trò để thiết lập:</label>
        <div class="role-tabs">
          <button 
            v-for="(config, role) in localData.roles" 
            :key="role"
            :class="{ 'active': selectedRole === role }"
            @click="selectedRole = role"
          >
            {{ mapRole(role) }}
          </button>
        </div>
      </div>

      <div v-if="localData.roles && localData.roles[selectedRole]" class="permissions-container">
        <div class="permissions-section">
          <h4><i class="fas fa-check-square"></i> Quyền thực thi (Permissions)</h4>
          <div class="checkbox-grid">
            <label v-for="permission in allPermissions" :key="permission.id" class="checkbox-item">
              <input 
                type="checkbox" 
                :value="permission.id" 
                v-model="localData.roles[selectedRole].permissions"
                @change="update"
              >
              <div class="checkbox-info">
                <span class="p-name">{{ permission.name }}</span>
                <span class="p-desc">{{ permission.desc }}</span>
              </div>
            </label>
          </div>
        </div>

        <div class="permissions-section mt-4">
          <h4><i class="fas fa-list"></i> Quyền truy cập Menu (Menu Access)</h4>
          <div class="checkbox-grid">
            <label v-for="menu in allMenus" :key="menu.id" class="checkbox-item">
              <input 
                type="checkbox" 
                :value="menu.id" 
                v-model="localData.roles[selectedRole].menus"
                @change="update"
              >
              <div class="checkbox-info">
                <span class="p-name">{{ menu.name }}</span>
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  data() {
    return {
      localData: JSON.parse(JSON.stringify(this.data)),
      selectedRole: 'admin',
      allPermissions: [
        { id: 'createOrder', name: 'Tạo đơn hàng', desc: 'Cho phép quét mã, tạo vận đơn mới' },
        { id: 'editPrice', name: 'Sửa giá', desc: 'Cho phép thay đổi đơn giá khi bán' },
        { id: 'viewProfit', name: 'Xem lợi nhuận', desc: 'Hiển thị giá vốn và lợi nhuận trên báo cáo' },
        { id: 'manageDebt', name: 'Quản lý công nợ', desc: 'Thu nợ khách hàng và trả nợ NCC' },
        { id: 'manageTransactions', name: 'Quản lý thu chi', desc: 'Thêm/Sửa/Xóa các phiếu thu chi sổ quỹ' },
        { id: 'manageProducts', name: 'Quản lý sản phẩm', desc: 'Chỉnh sửa thông tin hàng hóa, kho' },
        { id: 'manageCategories', name: 'Quản lý danh mục', desc: 'Thêm/Sửa/Xóa các loại nhóm sản phẩm' },
        { id: 'manageSuppliers', name: 'Quản lý nhà cung cấp', desc: 'Quản lý thông tin các đơn vị cung cấp hàng' },
        { id: 'manageCustomers', name: 'Quản lý khách hàng', desc: 'Quản lý thông tin và phân loại khách hàng' },
        { id: 'manageUsers', name: 'Quản lý nhân viên', desc: 'Thêm/Sửa/Xóa tài khoản nhân viên' },
        { id: 'viewReports', name: 'Xem báo cáo', desc: 'Truy cập các biểu đồ, thống kê doanh thu' }
      ],
      allMenus: [
        { id: 'home', name: 'Bán hàng (Trang chủ)' },
        { id: 'temporaryorder', name: 'Đơn tạm' },
        { id: 'admin', name: 'Admin (Tổng quan)' },
        { id: 'productlist', name: 'Sản phẩm' },
        { id: 'category', name: 'Danh mục' },
        { id: 'orderhistory', name: 'Lịch sử đơn' },
        { id: 'printedbills', name: 'Đơn đã in' },
        { id: 'returnhistory', name: 'Đơn hoàn' },
        { id: 'importhistory', name: 'Nhập kho' },
        { id: 'debt', name: 'Công nợ' },
        { id: 'transaction', name: 'Thu chi' },
        { id: 'supplier', name: 'Nhà cung cấp' },
        { id: 'customer', name: 'Khách hàng' },
        { id: 'revenuereport', name: 'Báo cáo doanh thu' },
        { id: 'user', name: 'Nhân viên' },
        { id: 'notifications', name: 'Thông báo' },
        { id: 'settings', name: 'Cấu hình' }
      ]
    }
  },
  watch: {
    data: {
      handler(val) {
        this.localData = JSON.parse(JSON.stringify(val));
        // Auto-select first role if current selected is invalid
        if (this.localData.roles && !this.localData.roles[this.selectedRole]) {
             const keys = Object.keys(this.localData.roles);
             if (keys.length > 0) this.selectedRole = keys[0];
        }
      },
      deep: true
    }
  },
  methods: {
    mapRole(role) {
      const maps = { admin: 'Quản trị', staff: 'Nhân viên', accountant: 'Kế toán' };
      return maps[role] || role;
    },
    update() {
      this.$emit('update', 'user', this.localData);
    }
  }
}
</script>



